import React from "react";
import { getLayoutProps } from "../../../services/serverSideRequests";
import {
  getArticles,
  fetchApi,
  getFrequentArticles,
} from "../../../services/requests";
import { ArticleListComponent } from "../index";

const ArticleList = (props) => {
  return <ArticleListComponent {...props} />;
};

export async function getServerSideProps(context) {
  const layoutProps = await getLayoutProps();
  const tag = context.params.tag;
  const offset = context.query.strona;

  const articlesPromise = getArticles({
    tags_slug: tag,
    limit: 12,
    offset: (offset - 1) * 12,
    site: 12,
  });

  const specialOfferPromise = fetchApi({
    url: "agrarlex-special-offer/?category=True&limit=1&random=True&site=12",
  });
  const articlesAuthorPromise = fetchApi({
    url: "contact-journalists/?site=12",
  });
  const mostReadPromise = getFrequentArticles({
    limit: 3,
  });

  const [articles] = await articlesPromise;
  const specialOffer = await specialOfferPromise;
  const articlesAuthor = await articlesAuthorPromise;
  const mostRead = await mostReadPromise;

  return {
    props: {
      ...layoutProps,
      category: null,
      mainCategory: null,
      subcategories: null,
      articles,
      specialOffer,
      articlesAuthor,
      mostRead,
    },
  };
}

export default ArticleList;
